"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const PreferencesManager_1 = require("@/client/utils/PreferencesManager");
const PreferencesDialog_vue_1 = __importDefault(require("@/client/components/PreferencesDialog.vue"));
exports.default = (0, vue_1.defineComponent)({
    name: 'PreferencesIcon',
    components: {
        'preferences-dialog': PreferencesDialog_vue_1.default,
    },
    data() {
        return {
            preferencesPanelOpen: false,
        };
    },
    computed: {
        preferencesManager() {
            return PreferencesManager_1.PreferencesManager.INSTANCE;
        },
    },
});
